export var PHOTO_CAROUSEL_SLIDE_POSITIONS = Object.freeze({
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
});